import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsToTime'
})
export class SecondsToTimePipe implements PipeTransform {
  transform(value: string): string {
    // Remove the " S" postfix
    const secondsString = value.replace(' S', '');

    // Convert the seconds string to a number
    const seconds = parseInt(secondsString, 10);

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    const formattedTime = `${hours}H ${minutes}M ${remainingSeconds}S`;

    return formattedTime;
  }
}
